import { GLOBAL_CONSTANTS } from 'utils/constants'
import Flickity from 'flickity-fade'

const SELECTORS = {
    COMPONENT: '.js-carousel'
}

export default class Carousel {

    constructor() {
        this.registerFlickity()
    }

    registerFlickity() {
        this.flickity = new Flickity(SELECTORS.COMPONENT, {
            prevNextButtons: false,
            lazyLoad: true,
            autoPlay: true,
            fade: true,
            arrowShape: GLOBAL_CONSTANTS.ARROW_SVG
        })
    }
}


export const CarouselComponent = {
    'name': 'Carousel',
    'class': SELECTORS.COMPONENT,
    'Source': Carousel
}
